/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListenStreakReminderNotificationActionData
 */
export interface ListenStreakReminderNotificationActionData {
    /**
     * 
     * @type {number}
     * @memberof ListenStreakReminderNotificationActionData
     */
    streak: number;
}

/**
 * Check if a given object implements the ListenStreakReminderNotificationActionData interface.
 */
export function instanceOfListenStreakReminderNotificationActionData(value: object): value is ListenStreakReminderNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "streak" in value && value["streak"] !== undefined;

    return isInstance;
}

export function ListenStreakReminderNotificationActionDataFromJSON(json: any): ListenStreakReminderNotificationActionData {
    return ListenStreakReminderNotificationActionDataFromJSONTyped(json, false);
}

export function ListenStreakReminderNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListenStreakReminderNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'streak': json['streak'],
    };
}

export function ListenStreakReminderNotificationActionDataToJSON(value?: ListenStreakReminderNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'streak': value.streak,
    };
}

